<template>
  <div>
    <form-wizard
      color="#0080C9"
      :title="null"
      :subtitle="null"
      layout="horizontal"
      :finish-button-text="submitting ? 'Guardando...' : (isEdit ? 'Actualizar' : 'Crear')"
      back-button-text="Atrás"
      next-button-text="Siguiente"
      class="mb-3"               
      :class="{ 'is-submitting': submitting }"
      @on-complete="finalizar"
    >
      <!-- Paso 1: Datos -->
      <tab-content title="Datos del paquete" :before-change="validarDatos">
        <!-- Fila 1: Nombre (8/12) + Precio (4/12) -->
        <b-row>
          <b-col md="8">
            <b-form-group label="Nombre del paquete">
              <b-form-input v-model.trim="form.nombre" required />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Precio (USD)">
              <b-form-input type="number" min="0" step="0.01" v-model.number="form.precio"/>
            </b-form-group>
          </b-col>
        </b-row>

        <!-- Fila 2: Descripción completa -->
        <b-row>
          <b-col>
            <b-form-group label="Descripción (opcional)">
              <b-form-textarea v-model.trim="form.descripcion" rows="2" />
            </b-form-group>
          </b-col>
        </b-row>

        <!-- Fila 3: Tipo de paquete + Estado (solo edición) -->
        <b-row>
          <b-col md="4">
            <b-form-group label="Tipo de paquete">
              <b-form-select v-model="form.tipoPaquete" :options="tipoPaqueteOptions" />
            </b-form-group>
          </b-col>
          <b-col md="4" v-if="isEdit">
            <b-form-group label="Estado">
              <b-form-checkbox switch v-model="estadoActivo">{{ estadoActivo ? 'Activo' : 'Inactivo' }}</b-form-checkbox>
            </b-form-group>
          </b-col>
        </b-row>

        <!-- Vigencia, Sexo y Edad se movieron a Reglas/Generales -->

        <!-- Fila 4: Selección de servicios (switches) -->
        <b-form-group label="¿Qué servicios incluirá este paquete?">
          <b-row>
            <b-col md="2" sm="4" cols="6">
              <b-form-checkbox switch v-model="serviceToggles.imagenes">Imágenes</b-form-checkbox>
            </b-col>
            <b-col md="2" sm="4" cols="6">
              <b-form-checkbox switch v-model="serviceToggles.laboratorio">Laboratorios</b-form-checkbox>
            </b-col>
            <b-col md="2" sm="4" cols="6">
              <b-form-checkbox switch v-model="serviceToggles.procedimientos">Procedimientos</b-form-checkbox>
            </b-col>
            <b-col md="2" sm="4" cols="6">
              <b-form-checkbox switch v-model="serviceToggles.terapias">Terapias</b-form-checkbox>
            </b-col>
            <b-col md="2" sm="4" cols="6">
              <b-form-checkbox switch v-model="serviceToggles.atencion_medica">Atenciones</b-form-checkbox>
            </b-col>
          </b-row>
        </b-form-group>
        <div class="mt-2">
          <LoadFileInput
            v-model="archivoImagenes"
            label="Imagen del paquete"
            :urlFile="urlCarpetaImagenes"
          />
        </div>
        <!-- Imagen del paquete se movió al paso Servicios -->
      </tab-content>

      <!-- Paso 2: Servicios -->
      <tab-content title="Servicios" :before-change="validarServicios">
        <PaqServicios
          :service-toggles="serviceToggles"
          :categorias="form.categorias"
          :buscar-laboratorios="buscarLaboratorios"
          :buscar-imagenes="buscarImagenes"
          :buscar-procedimientos="buscarProcedimientos"
          :buscar-terapias="buscarTerapias"
          @update-categoria="(k, v) => form.categorias[k] = v"
          @agregar="agregarServicio"
          @eliminar="eliminarServicio"
        />
      </tab-content>

      <!-- Paso 3: Reglas/Vigencia -->
      <tab-content title="Reglas">
        <PaqReglas v-model="rules" :categorias-keys="categoriasKeys" :labels-categorias="labelsCategorias" />
      </tab-content>

      <!-- Paso 4: Revisión -->
      <tab-content title="Revisión">
        <PaqVistaPrevia
          :nombre="form.nombre"
          :precio="form.precio"
          :imagen-src="portadaPreviewUrl"
          :descripcion="form.descripcion"
          :categorias="form.categorias"
          :labels-categorias="labelsCategorias"
          :beneficios="rules.beneficios"
          :notas-paciente="rules.generales.notasPaciente || form.notas"
        />
      </tab-content>
    </form-wizard>
  </div>
</template>
<script>
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import { FormWizard, TabContent } from "vue-form-wizard";
import { BRow, BCol, BFormGroup, BFormInput, BFormSelect, BFormTextarea, BFormCheckbox, BCard } from "bootstrap-vue";
import ServiceSelector from "../components/ServiceSelector";
import { imagenesService } from "@/views/imagen/services/imagenesService";
import { laboratoriosService } from '@/views/laboratorio/services/laboratoriosService'
import { procedimientosService } from "@/views/procesoclinico/services/procedimientosService";
// Subcomponentes de servicios están encapsulados en PaqServicios
import { LoadFileInput } from '@/shared/components'
import PaqReglas from '../components/PaqReglas.vue'
import PaqServicios from '../components/PaqServicios.vue'
import PaqVistaPrevia from '../components/PaqVistaPrevia.vue'
import { fileService } from '@/shared/services'
import rutas from '@/assets/utils/rutas.json'
import { paquetesService } from '../services'
import { terapiasCarteraService } from '@/views/terapia/services'
export default {
  name: "CrearPaquete",
  components: {
    FormWizard, TabContent,
    BRow, BCol, BFormGroup, BFormInput, BFormSelect, BFormTextarea, BFormCheckbox, BCard,
    ServiceSelector,
    LoadFileInput, PaqReglas, PaqServicios, PaqVistaPrevia 
  },
  data() {
    return {
      submitting: false,
      archivoImagenes: null,        // v-model del LoadFileInput
      urlCarpetaImagenes: null,     // url previa (si estás editando)
      portadaUrl: null, 
      // controles de visibilidad de secciones de servicios
      // (fuente de verdad única para evitar loops)
      // categoriasSeleccionadas removido
      serviceToggles: {
        imagenes: false,
        laboratorio: false,
        procedimientos: false,
        terapias: false,
        atencion_medica: false,
      },
      form: {
        nombre: "",
        descripcion: "",
        precio: null,
        tipoPaquete: '',
        permiteAgendar: true,
        requiereOrden: false,
        visibleTienda: true,
        notas: "",
        categorias: {
          laboratorio: [],
          imagenes: [],
          procedimientos: [],
          atencion_medica: [],
          terapias: [],
        },
      },
      // Reglas de negocio del paquete
      rules: {
        generales: { sexo: null, edadMin: null, edadMax: null },
        canales: { web: false, sucursal: false, callCenter: false },
        segmentacion: { embarazo: false, terceraEdad: false },
        requisitos: {
          ordenMedicaPorServicio: { laboratorio: false, imagenes: false, procedimientos: false, terapias: false, atencion_medica: false },
          precondiciones: { ayuno: false, chequeoCardiologo: false }
        },
        sedesElegibles: [],
        pagos: {
          formas: { efectivo: false, tarjeta: false, financiamiento: false },
          reembolso: { diasLimite: null, bloquearCancelacionConUso: false, parcialPorcentaje: null, retencionAdministrativaPct: null }
        },
        serviciosExtra: {
          imagenes: { solicitarSedacion: false },
          laboratorio: { familiasLimitadas: [] },
          terapias: { maxSesionesSemanales: null, caducidadPorSesionDias: null }
        },
        beneficios: { parkingGratis: false, salaVIP: false, bebidas: false },
        recordatorios: { frecuenciaDias: null, canales: { sms: false, email: false, whatsapp: false } },
        caducidad: {
          duracionEnabled: false,
          venceEn: null,
          activacionDiferidaEnabled: false,
          activacionDesde: null,
          congelamientoEnabled: false,
          congelamientoMaxDias: 0,
          blackoutEnabled: false,
          blackouts: [] // [{desde, hasta}]
        },
        usos: {
          topePorServicioEnabled: false,
          topePorCategoria: { laboratorio: null, imagenes: null, procedimientos: null, terapias: null, atencion_medica: null },
          frecuenciaMinimaEnabled: false,
          frecuenciaMinimaDias: null,
          concurrenciaEnabled: false,
          transferibleEnabled: false,
          compartibleEnabled: false,
        },
        precios: {
          dinamicoEnabled: false,
          dinamicoDesde: null,
          dinamicoHasta: null,
          dinamicoDescuentoPct: null,
          diasEspecialesEnabled: false,
          diasEspeciales: [], // [{desde, hasta}]
          volumenEnabled: false,
          volumenEscalas: [], // [{cantidadMin, descuentoPct}]
          ventaCruzadaEnabled: false,
          ventaCruzadaDescuentoPct: null,
          ventaCruzadaPaquete: '',
          referralEnabled: false,
          referralTipo: null,
          convenioEnabled: false,
          convenio: null,
        }
      },
      // auxiliares de UI movidos al componente PaqReglas
      categoriasKeys: ['laboratorio','imagenes','procedimientos','terapias','atencion_medica'],
      labelsCategorias: {
        laboratorio: 'Laboratorios',
        imagenes: 'Imágenes',
        procedimientos: 'Procedimientos',
        terapias: 'Terapias',
        atencion_medica: 'Atenciones',
      },
      // Valores mapeados al backend: 1=Básico, 2=Intermedio, 3=Full
      tipoPaqueteOptions: [
        { value: '', text: 'Seleccione...' },
        { value: '1', text: 'Básico' },
        { value: '2', text: 'Intermedio' },
        { value: '3', text: 'Full' },
      ],
      editId: null,
      estadoActivo: true,
    };
  },
  props: {
    embedded: { type: Boolean, default: false },
    editToken: { type: String, default: null },
    prefillData: { type: Object, default: null },
    editIdProp: { type: [Number, String], default: null },
  },
  computed: {
    isEdit(){ return !!(this.editId || this.editToken) },
    portadaPreviewUrl () {
      // Prioridad: objeto File -> URL temporal; si no, usar portadaUrl o urlCarpetaImagenes
      const f = this.archivoImagenes
      if (f && typeof f === 'object' && f.size) {
        try { return URL.createObjectURL(f) } catch (e) { /* noop */ }
      }
      const raw = this.portadaUrl || this.urlCarpetaImagenes || ''
      if (!raw) return ''
      const s = String(raw)
      // Si no es absoluta ni blob, componer con backend file/show
      if (/^(https?:)?\/\//.test(s) || s.startsWith('blob:')) return s
      return `${rutas.axios}file/show${s}`
    },
    jsonPaquete() {
      // estructura pensada para guardar en BD más adelante
      // Mapear tipo de paquete a lo que espera backend (char '1'|'2'|'3')
      const map = { BASICO: '1', INTERMEDIO: '2', FULL: '3', '1': '1', '2': '2', '3': '3' }
      const tipoPkg = map[this.form.tipoPaquete] || ''

      return {
        nombre: this.form.nombre,
        descripcion: this.form.descripcion,
        precio: this.form.precio,
        tipoPaquete: tipoPkg,
        // vigencia y target se gestionan ahora en rules.generales/caducidad
        flags: {
          permite_agendar: this.form.permiteAgendar,
          requiere_orden: this.form.requiereOrden,
          visible_tienda: this.form.visibleTienda,
        },
        // excluir "agenda" de las reglas (no aplica al negocio)
        reglas: (() => { const { agenda, ...rest } = this.rules || {}; return rest })(),
        notas: this.form.notas,
        servicios: this.form.categorias, // {laboratorio:[], imagenes:[], ...}
        portada_url: this.portadaUrl || this.urlCarpetaImagenes || null,
      };
    },
    jsonPaqueteBonito() {
      return JSON.stringify(this.jsonPaquete, null, 2);
    },
  },
  // mounted no requerido; sedes se cargan en PaqReglas
  created(){
    // Modo edición por token (modal) o por id de la ruta
    if (this.editIdProp) {
      this.editId = this.editIdProp
    }
    if (this.prefillData) {
      this.applyJson(this.prefillData)
    }
    if (this.editToken) {
      this.cargarPaquetePorToken(this.editToken)
    } else {
      const maybeId = this.$route?.params?.id
      if (maybeId) {
        this.editId = maybeId
        this.cargarPaquetePorId(maybeId)
      }
    }
  },
  methods: {
    applyJson(json){
      if (!json) return
      this.form.nombre = json.nombre || ''
      this.form.descripcion = json.descripcion || ''
      this.form.precio = json.precio || null
      this.form.tipoPaquete = json.tipoPaquete || ''
      this.form.permiteAgendar = json?.flags?.permite_agendar ?? true
      this.form.requiereOrden = json?.flags?.requiere_orden ?? false
      this.form.visibleTienda = json?.flags?.visible_tienda ?? true
      this.form.notas = json?.notas || ''
      this.form.categorias = { laboratorio: [], imagenes: [], procedimientos: [], terapias: [], atencion_medica: [], ...(json?.servicios || {}) }
      Object.keys(this.serviceToggles).forEach(k => { this.serviceToggles[k] = Array.isArray(this.form.categorias[k]) && this.form.categorias[k].length > 0 })
      this.rules = { ...this.rules, ...(json?.reglas || {}) }
      this.urlCarpetaImagenes = json?.portada_url || null
      this.portadaUrl = json?.portada_url || null
    },
    async cargarPaquetePorId(id){
      try{
        const rs = await paquetesService.getById(id)
        const raw = rs?.json_paquete
        if (!raw) return
        let json
        try{ json = typeof raw === 'object' ? raw : JSON.parse(String(raw)) }catch(e){ json = {} }
        this.estadoActivo = String(rs?.estadoactivo ?? '1') === '1'
        this.applyJson(json)
      } catch (e) {
        console.error('Error cargando paquete', e?.response?.data || e)
      }
    },
    async cargarPaquetePorToken(token){
      try{
        const rs = await paquetesService.getByToken(token)
        if(rs?.id) this.editId = rs.id
        const raw = rs?.json_paquete
        if (!raw) return
        let json
        try{ json = typeof raw === 'object' ? raw : JSON.parse(String(raw)) }catch(e){ json = {} }
        this.estadoActivo = String(rs?.estadoactivo ?? '1') === '1'
        this.applyJson(json)
      } catch (e) {
        console.error('Error cargando paquete (token)', e?.response?.data || e)
      }
    },
      
      async buscarLaboratorios(q) {
      if (!q || q.trim().length < 3) return []

      const rs = await laboratoriosService.getAllSns(q.trim())
      return (rs || []).map(item => ({
        codigo: item.codigo,
        descripcion: item.descripcion,
        label: `(${item.codigo}) ${item.descripcion}`
      }))
    },


     async buscarTerapias (q) {
      if (!q || q.trim().length < 3) return []

      const params = { search: q.trim() }

      const response = await terapiasCarteraService.getAll(params)
      if (!response) return []

      // normalizar al formato esperado por PaqTerapia
      return response.map(t => ({
        id: t.id,
        descripcion: t.nombre,
        label: `(${t.codigo}) ${t.nombre}`
      }))
    },

    async buscarProcedimientos(q) {
      const rs = await procedimientosService.searchSns(q || "")
      return (rs || []).map(p => ({
        id: p.value,
        codigo: p.codigo,
        descripcion: p.text,
      }))
    },


    isCatSelected(key) {
      return !!this.serviceToggles[key]
    },


    async subirPortadaSiCorresponde () {
    // NOTA del componente:
    // - null       => no hubo interacción
    // - undefined  => usuario pulsó "eliminar"
    // - File       => usuario seleccionó archivo nuevo

    let urlActual = this.urlCarpetaImagenes || null

    if (this.archivoImagenes !== null) {
      if (this.archivoImagenes === undefined) {
        // eliminar
        if (urlActual) await fileService.deleteFile(urlActual)
        urlActual = null
      } else {
        // subir (usa exactamente tu firma/valores de ejemplo)
        urlActual = await fileService.upload(
          'informeImagen',          // bucket/carpeta lógica (tu ejemplo)
          this.archivoImagenes,     // File
          'imagenes',               // subcarpeta
          this.urlCarpetaImagenes   // url antigua (para reemplazo)
        )
      }
    }
        this.urlCarpetaImagenes = urlActual
    this.portadaUrl = urlActual
  },

  async finalizar () {
      if (this.submitting) return
      this.submitting = true
      // Asegurar que en modo edición tengamos el ID antes de decidir la mutación
      if (!this.editId && this.editToken) {
        try { await this.cargarPaquetePorToken(this.editToken) } catch (e) { /* noop */ }
      }
      await this.subirPortadaSiCorresponde()
      const payload = {
        ...this.jsonPaquete,
        portada_url: this.portadaUrl || null,
      }
      const json = JSON.stringify(payload)
      try {
        const resp = this.editId
          ? await paquetesService.actualizarJsonPaquete(this.editId, json)
          : await paquetesService.enviarJsonPaquete(json)
        if (this.editId) {
          try { await paquetesService.setEstadoActivo(this.editId, this.estadoActivo ? '1' : '0') } catch (e) { /* noop */ }
        }
        if (resp?.status === 'OK' || resp?.id) {
          this.$bvToast && this.$bvToast.toast('Paquete creado correctamente.', { variant: 'success' })
        } else {
          this.$bvToast && this.$bvToast.toast('Paquete enviado.', { variant: 'success' })
        }
        if (this.embedded) {
          this.$emit('saved')
        } else {
          // Redirigir al listado
          this.$router.push({ name: 'consultar_paquetes_preventivos' }).catch(() => {})
        }
      } catch (e) {
        console.error('PAQUETE_ERR', e?.response?.data || e)
        this.$bvToast && this.$bvToast.toast('Error al enviar paquete (ver consola).', { variant: 'danger' })
        this.submitting = false
      }
  },
    

  // ya tienes esta para imágenes; la dejo aquí sólo de referencia
    async buscarImagenes(q) {
        const rs = await imagenesService.getAllSns(q || '')
        return (rs || []).map(i => ({
          id: i.id ?? i.token ?? i.codigo,
          codigo: i.codigo,
          descripcion: i.nombre,
        }))
      },
    // —— CRUD local de items seleccionados ——
    agregarServicio(cat, item) {
      this.form.categorias[cat].push(item);
    },
    eliminarServicio(cat, index) {
      this.form.categorias[cat].splice(index, 1);
    },

    // —— validaciones de pasos ——
    async validarDatos() {
      // Nombre requerido
      if (!this.form.nombre || !this.form.nombre.trim()) {
        this.$bvToast.toast('El nombre del paquete es obligatorio.', { variant: 'danger' })
        return false
      }
      // Precio requerido (permitimos 0 como válido)
      if (this.form.precio === null || this.form.precio === undefined || this.form.precio === '') {
        this.$bvToast.toast('El precio es obligatorio.', { variant: 'danger' })
        return false
      }
      if (Number.isNaN(Number(this.form.precio)) || Number(this.form.precio) < 0) {
        this.$bvToast.toast('El precio debe ser un número válido (>= 0).', { variant: 'danger' })
        return false
      }
      // Debe haber al menos un servicio marcado (validación temprana en Paso 1)
      const algunoMarcado = Object.values(this.serviceToggles).some(Boolean)
      if (!algunoMarcado) {
        this.$bvToast.toast('Debe seleccionar al menos un servicio.', { variant: 'danger' })
        return false
      }
      return true
    },
    async validarServicios() {
      // Requiere al menos un servicio marcado
      const algunoMarcado = Object.values(this.serviceToggles).some(Boolean)
      if (!algunoMarcado) {
        this.$bvToast.toast('Debe seleccionar al menos un servicio.', { variant: 'danger' })
        return false
      }
      return true
    },

    
  },
   watch: {
    // Cuando se apaga un switch, limpiamos sus items
    serviceToggles: {
      deep: true,
      handler(v, old) {
        Object.keys(this.form.categorias).forEach(k => {
          if (!v[k]) this.form.categorias[k] = []
        })
      }
    }
  },
}
</script>

<style scoped>
/* detalles mínimos para separar secciones */
.is-submitting .wizard-btn {
  pointer-events: none;
  opacity: 0.7;
}
</style>
